import React from "react";
import './style.css'
import { BsInstagram } from "react-icons/bs";
import { BsLinkedin } from "react-icons/bs";

const Social = () => {
  return (
    <div className="socialemail">
      <div className="social">
        <div className="insta icons">
          <a className="social__icon" href="https://www.instagram.com/abhijith98/" target='_blank'><BsInstagram /></a>
        </div>
        <div className="linkedin icons">
          <a className="social__icon" href="https://www.linkedin.com/in/abhijith-pillai-6a9609212/" target='_blank'><BsLinkedin /></a>
        </div>
        <div className="line"></div>
      </div>

      <div className="gmail">
        <a href="mailto:abhijithpillai174@gmail.com" target='_blank'><p className="mail">abhijithpillai174@gmail.com</p></a>
        <p className="lin"></p>
      </div>
    </div>
  );
};

export default Social;
